import { useQuery } from '@tanstack/react-query';
import { Plus, Building } from 'lucide-react';
import { api, Partner } from '../../lib/api';

export function PartnerListPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['partners'],
    queryFn: () => api.get<{ data: Partner[] }>('/api/partners'),
  });
  const typeLabels: Record<string, string> = { customer: '得意先', vendor: '仕入先', both: '得意先/仕入先' };

  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold" style={{ color: 'var(--text-primary)' }}>取引先マスタ</h1>
        <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-white font-medium" style={{ backgroundColor: 'var(--accent-color)' }}><Plus size={18} />新規登録</button>
      </div>
      <div className="card overflow-hidden">
        {isLoading ? (
          <div className="flex items-center justify-center h-64"><div className="w-8 h-8 border-2 border-blue-600/30 border-t-blue-600 rounded-full animate-spin" /></div>
        ) : data?.data.length === 0 ? (
          <div className="text-center py-12"><Building size={48} className="mx-auto mb-4" style={{ color: 'var(--text-muted)' }} /><p style={{ color: 'var(--text-secondary)' }}>取引先が登録されていません</p></div>
        ) : (
          <table>
            <thead><tr>
              <th style={{ color: 'var(--text-primary)' }}>コード</th>
              <th style={{ color: 'var(--text-primary)' }}>取引先名</th>
              <th style={{ color: 'var(--text-primary)' }}>区分</th>
              <th style={{ color: 'var(--text-primary)' }}>インボイス番号</th>
              <th style={{ color: 'var(--text-primary)' }}>電話番号</th>
              <th style={{ color: 'var(--text-primary)' }}>状態</th>
            </tr></thead>
            <tbody>
              {data?.data.map((partner) => (
                <tr key={partner.id}>
                  <td className="font-mono" style={{ color: 'var(--text-primary)' }}>{partner.code}</td>
                  <td style={{ color: 'var(--text-primary)' }}>{partner.name}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{typeLabels[partner.partnerType] || partner.partnerType}</td>
                  <td className="font-mono" style={{ color: 'var(--text-secondary)' }}>{partner.invoiceNumber || '-'}</td>
                  <td style={{ color: 'var(--text-secondary)' }}>{partner.phone || '-'}</td>
                  <td><span className={`badge ${partner.isActive ? 'badge-success' : 'badge-error'}`}>{partner.isActive ? '有効' : '無効'}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

